import React from 'react';
import '../css/page.css';
import Footer from '../component/Footer';
import doctor from '../img/ABOUT.jpg';

const Manish = () => {
    return (
        <>


            <div class="breadcrumb">
                <a href="/">Home</a> / Meet Our Doctor
            </div>


            <div className="profile-page container manish">
                <div className="doctor-info my-4 text-center">
                    <img src={doctor} alt="Dr. Manish Khattar" className="doctor-img mb-3" />
                    <h2>Dr. Manish Khattar</h2>
                    <p>
                        <strong>Designation:</strong> Consultant<br />
                        <strong>Specialty:</strong> Urology, Robotics, and Kidney Transplant<br />
                        <strong>Mobile (e-clinic):</strong> 9899450611
                    </p>
                </div>

                <div className="mb-5">
                    <h4>Medical Profile</h4>

                    <div className="mb-4">
                        <h5>Qualifications</h5>
                        <table className="table table-bordered">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Qualification</th>
                                    <th>Institute/Department</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>MCh Urology</td>
                                    <td>AIIMS Delhi</td>
                                </tr>
                                <tr>
                                    <td>MS General Surgery</td>
                                    <td>AIIMS Delhi</td>
                                </tr>
                                <tr>
                                    <td>MBBS</td>
                                    <td>AIIMS Delhi</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="mb-4">
                        <h5>Specialization/Expertise</h5>
                        <ol>
                            <li>Uro-oncology</li>
                            <li>Andrology</li>
                            <li>Kidney Transplant</li>
                            <li>Robotics</li>
                            <li>Reconstructive Urology</li>
                        </ol>
                    </div>

                    <div className="mb-4">
                        <h5>Membership & Certifications</h5>
                        <p>USI &ndash; K528</p>
                    </div>

                    <div className="mb-4">
                        <h5>Awards & Accomplishments</h5>
                        <p>Example: BC Roy Award, Padma Shri, etc.</p>
                    </div>

                    <div className="mb-4">
                        <h5>Publications</h5>
                        <p>Include name of the research article, publication, and web link.</p>
                    </div>



                    <div className="mb-4">
                        <h5>Past Experience</h5>
                        <ul>
                            <li>Senior registrar at RMLIMS, Lucknow</li>
                            <li>Consultant Urology at Chandan Hospital, Lucknow</li>
                        </ul>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Manish;
